import React from 'react';
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import HeaderMobileMenu from './HeaderMobileMenu';
import HeaderDesktopMenu from './HeaderDesktopMenu';

const useStyles = makeStyles(theme => ({
	grow: {
		flexGrow: 1,
		position: 'relative',
		zIndex: theme.zIndex.drawer + 1
	}
}));

export default function PrimarySearchAppBar({ isMobile }) {
	const classes = useStyles();
	const location = useLocation();

	const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
	const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

	function handleMobileMenuClose() {
		setMobileMoreAnchorEl(null);
	}

	function openMobileMenu(event) {
		setMobileMoreAnchorEl(event.currentTarget);
	}

	if (location.pathname.startsWith('/discord_cards')) return null;

	return (
		<div className={classes.grow}>
			<HeaderDesktopMenu openMobileMenu={openMobileMenu} />
			<HeaderMobileMenu
				isOpen={isMobileMenuOpen}
				anchorEl={mobileMoreAnchorEl}
				handleClose={handleMobileMenuClose}
			/>
		</div>
	);
}
